import React, { useMemo } from 'react';
import OpenFormDatePicker from './OpenFormDatePicker';

const TIMEZONE_OPTIONS = [
  'UTC',
  'GMT',
  'EST',
  'EDT',
  'CST',
  'CDT',
  'MST',
  'MDT',
  'PST',
  'PDT',
  'AKST',
  'AKDT',
  'HST',
  'AST',
  'ADT',
  'NST',
  'IST',
  'CET',
  'CEST',
  'EET',
  'EEST',
  'GST',
  'SGT',
  'JST',
  'AEST',
  'AEDT',
];

const getTimezoneOptions = () => {
  return TIMEZONE_OPTIONS.map((timeZone) => ({
    value: timeZone,
    label: timeZone,
  }));
};

const formatReadOnlyDateTime = (value) => {
  const text = String(value || '').trim();
  const dayFirstMatch = text.match(/^(\d{2})-(\d{2})-(\d{4})(.*)$/);
  if (dayFirstMatch) {
    return `${dayFirstMatch[2]}/${dayFirstMatch[1]}/${dayFirstMatch[3]}${dayFirstMatch[4]}`;
  }

  const isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})(.*)$/);
  if (isoMatch) {
    return `${isoMatch[2]}/${isoMatch[3]}/${isoMatch[1]}${isoMatch[4].replace(/^T/, ' ')}`;
  }

  return text;
};

export default function OpenFormDateTimeField({
  id,
  name,
  label,
  value,
  onChange,
  timezoneId,
  timezoneName,
  timezoneValue,
  required = false,
  readOnly = false,
  max,
  error = false,
}) {
  const timezoneOptions = useMemo(getTimezoneOptions, []);

  return (
    <div className="open-form-field open-form-datetime-zone-field">
      <label htmlFor={id}>
        {required ? (
          <>
            <span className="required mandatory-required">*</span>
            {' '}
          </>
        ) : null}
        {label}
      </label>
      <div className="open-form-datetime-zone-control">
        {readOnly ? (
          <input
            id={id}
            name={name}
            value={formatReadOnlyDateTime(value)}
            readOnly
          />
        ) : (
          <OpenFormDatePicker
            id={id}
            name={name}
            type="datetime"
            value={value}
            onChange={onChange}
            max={max}
            error={error}
          />
        )}
        <select
          id={timezoneId}
          name={timezoneName}
          value={timezoneValue}
          onChange={onChange}
          aria-label={`${label} timezone`}
        >
          <option value="">Timezone</option>
          {timezoneOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
